import { useMemo } from 'react'

import { Formik, Form } from 'formik'
import { object, SchemaOf, string } from 'yup'

import { FormTextField, noWhitespaces } from '@collaborate-health/forms'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@collaborate-health/uikit'
import { maxLength as maxLengthMessage } from '@tabeeb/shared/utils/validationErrorMessages'

export interface RejectCertificateDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: (reason?: string | null) => void
}

interface RejectCertificateFormValues {
  reason?: string | null
}

const RejectCertificateDialog: React.FC<RejectCertificateDialogProps> = ({ open, onClose, onSubmit }) => {
  const schema = useMemo<SchemaOf<RejectCertificateFormValues>>(
    () =>
      object({
        reason: string().optional().nullable().trim(noWhitespaces).max(10000, maxLengthMessage(10000)),
      }),
    []
  )

  const handleSubmit = ({ reason }: RejectCertificateFormValues) => {
    onSubmit(reason)
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Are you sure you want to reject the certificate?</DialogTitle>
      <Formik enableReinitialize initialValues={{ reason: null }} validationSchema={schema} onSubmit={handleSubmit}>
        {({ isValid, isSubmitting }) => (
          <Form style={{ display: 'contents' }} autoComplete='off'>
            <DialogContent>
              <FormTextField name='reason' label='Rejection reason' multiline minRows={4} maxRows={10} autoFocus />
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button
                variant='contained'
                color='error'
                type='submit'
                loading={isSubmitting}
                disabled={!isValid || isSubmitting}
              >
                Reject
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

export default RejectCertificateDialog

